/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon16Solid = forwardRef('CheckSquareCutIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 1A3.5 3.5 0 0 0 1 4.5v7A3.5 3.5 0 0 0 4.5 15h7a3.5 3.5 0 0 0 3.5-3.5v-7c0-.169-.012-.335-.035-.498L9.09 9.876a2.25 2.25 0 0 1-3.182 0L3.918 7.885A1 1 0 0 1 5.332 6.47l1.991 1.99a.25.25 0 0 0 .354 0l6.366-6.366A3.49 3.49 0 0 0 11.5 1h-7Z" })));
});
